<template>
  <div>
    <div id="slideTab">
      <a href="javascript:void(0)" class="go--list" @click="toggleBtn($event)">목록으로</a>
      <swiper :options="swiperOption" style="width:calc(100% - 40px);padding:10px 0;overflow-x: hidden;display:flex;" >
        <swiper-slide class="swiper-slide swiper--tab--btn" v-for="(tab, index) in tabs" :key="index" v-show="tabs[tabs.length - index - 1].show" :id="index">
          <a href="javascript:;" @click="currentTab = index">{{tabs[tabs.length - index - 1].tabName}}</a><button type="button" class="tab--close" @click="removeTab(tabs[tabs.length - index - 1], index, tabs.length - index - 1)">닫기</button>
        </swiper-slide>
      </swiper>
    </div>
    <div>
      <div v-for="(tab, index) in tabs" v-bind:key="index" v-show="(tabs.length - currentTab - 1) === index && tabs[tabs.length - currentTab - 1].show">
        <component v-bind:is="tab.tabComponent"></component>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.min.css'
import { eventBus } from '@/event-bus'

export default {
  components: {
    swiper,
    swiperSlide
  },

  props: {
    defaultTabs: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 15, // swiper-slide 사이의 간격 지정
        slidesOffsetBefore: 20, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
        slidesOffsetAfter: 20, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
        freeMode: true // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
      },
      tabs: [],
      currentTab: 0
    }
  },

  created () {
    // console.log("created SideTabView..")
    this.tabs = this.defaultTabs

    eventBus.$on('setTabs', (res) => {
      let haveTab = false // 탭이 존재하는지 확인
      let selectTab = 0
      for (const stat of this.tabs) {
        selectTab = selectTab + 1

        if (stat.tabName === res.tabName && stat.show === res.show) {
          haveTab = true
          this.currentTab = this.tabs.length - selectTab
          break
        }
      }
      if (!haveTab) {
        const tab = {
          tabName: res.tabName,
          tabComponent: res.tabComponent,
          show: true
        }
        this.$set(this.tabs, this.tabs.length, tab)

        this.currentTab = 0

        this.$router.push({ name: res.tabName }).catch(() => {})
      }
    })
  },

  methods: {
    // 메뉴 토글
    toggleBtn () {
      this.$emit('toggle', this.toggle)
    },
    // 탭 제거하기
    removeTab (removeTab, tabIndex, removeIndex) {
      let changeTabIndex = tabIndex

      for (let idx = 0; idx < this.tabs.length; idx++) {
        if (this.tabs[idx].tabName === removeTab.tabName && this.tabs[idx].show === removeTab.show) {
          if (tabIndex === idx) {
            changeTabIndex = idx - 1
          }

          let tabCount = 0

          for (let j = 0; j < this.tabs.length; j++) {
            if (this.tabs[j].show) {
              tabCount++
            }
          }

          if (this.tabs.length === 1 || tabCount === 1) {
            break
          }

          this.tabs[idx].show = false

          this.$nextTick(function () {
            if (this.currentTab === tabIndex) { // 선택된 탭을 닫을 때 동작
              if (this.currentTab < removeIndex) {
                for (let j = removeIndex; j >= 0; j--) {
                  if (this.tabs[j].show) {
                    this.currentTab = this.tabs.length - j - 1
                    break
                  }
                }
              } else {
                for (let j = removeIndex; j < this.tabs.length; j++) {
                  if (this.tabs[j].show) {
                    this.currentTab = this.tabs.length - j - 1
                    break
                  }
                }
              }
            }
          })

          break
        }
      }

      if (changeTabIndex < 1) {
        this.currentTab = 0
      }
    }
  },
  destroyed () {
    // eventBus.$off('setTabs')
  }
}
</script>
